import LayoutProvider from '../providers/LayoutProvider';

import Footer from '../app/pages/Footer';

export type MrtFooterProps = {
  targetEnv: string;
  defaultIsMobile?: boolean;
};

const MrtFooter = ({ targetEnv, defaultIsMobile }: MrtFooterProps) => {
  return (
    <LayoutProvider targetEnv={targetEnv} defaultIsMobile={defaultIsMobile}>
      <Footer />
    </LayoutProvider>
  );
};

export default MrtFooter;
